import { render, staticRenderFns } from "./CandidatesLogTabs.vue?vue&type=template&id=5a539a20&lang=pug"
import script from "./CandidatesLogTabs.vue?vue&type=script&lang=js"
export * from "./CandidatesLogTabs.vue?vue&type=script&lang=js"
import style0 from "./CandidatesLogTabs.vue?vue&type=style&index=0&id=5a539a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports